<div class="flex justify-content-end mb-4 gap-2">
    <p-button *ngIf="selectedWorkerCalendarEvents.length > 0" type="button" label="Eliminar todo" icon="pi pi-trash" severity="danger" (click)="deleteMultipleWorkerCalendarEvents()"></p-button>
    <p-button type="button" label="Añadir evento" icon="pi pi-plus" (click)="newWorkerCalendarEvent()"></p-button>
</div>
<p-table [value]="workerCalendarEvents"
    [paginator]="false" [rows]="25"  [(selection)]="selectedWorkerCalendarEvents">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 40px;">
                
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Tipo</th>
            <th>Fecha</th>
            <th>Desde</th>
            <th>Hasta</th>
            <th>Descripción</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-workerCalendarEvent>
        <tr [pSelectableRow]="workerCalendarEvent" >
             <td>
                <p-tableCheckbox *ngIf="workerCalendarEvent.calendarEventType?.name != 'Cita'" [value]="workerCalendarEvent"></p-tableCheckbox>
            </td>
            <td>{{ workerCalendarEvent.calendarEventType?.name }}</td>
            <td>{{ (workerCalendarEvent.date | date: 'dd/MM/yyyy') }}</td>
            <td>{{ workerCalendarEvent.start }}</td>
            <td>{{ workerCalendarEvent.end }}</td>
            <td>{{ workerCalendarEvent.description }}</td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="workerCalendarEvent.calendarEventType?.name != 'Cita'" type="button" icon="pi pi-trash" [rounded]="true" [text]="false" severity="danger"
                        (click)="deleteWorkerCalendarEvent(workerCalendarEvent)"></p-button>
                    <p-button *ngIf="workerCalendarEvent.calendarEventType?.name != 'Cita'" type="button" icon="pi pi-pencil" [rounded]="true" [text]="false"
                        (click)="editWorkerCalendarEvent(workerCalendarEvent)"></p-button>
                    <p-button *ngIf="workerCalendarEvent.calendarEventType?.name == 'Cita'" type="button" icon="pi pi-eye" [rounded]="true" [text]="false"
                        (click)="editWorkerCalendarEvent(workerCalendarEvent)"></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>